// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WmDI","label":"styles_label__2_vV2"};